import React, { FC } from 'react';
import classNames from 'classnames';
import { numberWithSpaces } from '../../../utils/math';
import styles from './entity_block_line.module.scss';
import { EntityBlockLineSearchLabel } from './EntityBlockLineSearchLabel';
import { EntityBlockLineHoverHyperlink } from './EntityBlockLineHoverHyperlink';

type Props = {
  label: string;
  value: number;
  url?: string;
  source: string;
  indent?: boolean;
};

export const EntityBlockLine: FC<Props> = ({
  label,
  value,
  url,
  source,
  indent = false,
}) => {
  return (
    <EntityBlockLineHoverHyperlink source={source} url={url}>
      {(isHovered) => (
        <>
          <EntityBlockLineSearchLabel
            indent={indent}
            label={label}
            isHovered={isHovered}
          />
          <span
            className={classNames(styles.value, {
              [styles.hover]: isHovered,
            })}
          >
            {numberWithSpaces(value)}
          </span>
        </>
      )}
    </EntityBlockLineHoverHyperlink>
  );
};
